module.exports = __webpack_public_path__ + "img/tab-14.8b5c8a77.png";